import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IPagesDefinition, IPagesServiceConfig, Page } from '@wix/site-service-pages/definition'
import { PagesDefinition as definition } from '@wix/site-service-pages/definition'
import { PagesService as impl } from '@wix/site-service-pages/implementations'
import { name } from './symbols'

const EMPTY_PAGE: Page = { id: '', title: '', path: '', popup: false }
const EMPTY_PAGES_CONFIG: IPagesServiceConfig = { pages: {}, mainPage: EMPTY_PAGE, currentPage: EMPTY_PAGE }

export const siteSitePagesService: FactoryWithDependencies<ServiceProvider<IPagesDefinition, typeof impl>> =
	withDependencies(
		[],
		(): ServiceProvider<IPagesDefinition, typeof impl> => ({
			definition,
			impl,
			config: EMPTY_PAGES_CONFIG,
			platformConfig: EMPTY_PAGES_CONFIG,
		})
	)

export const SitePagesService: FactoryWithDependencies<ServiceProvider<IPagesDefinition, typeof impl>> =
	withDependencies(
		[named(PageFeatureConfigSymbol, name)] as const,
		(config: IPagesServiceConfig): ServiceProvider<IPagesDefinition, typeof impl> => ({
			definition,
			impl,
			config,
			platformConfig: config,
		})
	)
